if (!customElements.get('wlsn-cart-upgrade-item')) {
  class WLSNCartUpgradeItem extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        loading: 'loading',
      };

      this.bindMethods = {
        handleUpgradeClick: this._handleUpgradeClick.bind(this),
      };
    }

    get elements() {
      return {
        btn: this.querySelector('.js-wlsn-cart-upgrade-btn'),
      };
    }

    connectedCallback() {
      this._attachEventListeners();
    }

    disconnectedCallback() {
      this._detachEventListeners();
    }

    _attachEventListeners() {
      const { btn } = this.elements;
      if (btn) btn.addEventListener('click', this.bindMethods.handleUpgradeClick);
    }

    _detachEventListeners() {
      const { btn } = this.elements;
      if (btn) btn.removeEventListener('click', this.bindMethods.handleUpgradeClick);
    }

    async _handleUpgradeClick() {
      const lineKey = this.dataset.lineItemKey;
      const variantId = this.dataset.variantId;
      const sellingPlanId = this.dataset.sellingPlanId || null;
      if (!lineKey || !variantId) return;

      window.WLSNHelpers.triggerEvent(this, 'wlsn:cart:update:cart:line', { lineKey, variantId, sellingPlanId });
    }
  }
  customElements.define('wlsn-cart-upgrade-item', WLSNCartUpgradeItem);
}